import axiosInstance from "@/axiosInstance";

const state = () => ({
  stock_requests: [],
  requestsLoaded: false,
});

const mutations = {
  SET_STOCK_REQUESTS(state, stock_requests) {
    state.stock_requests = stock_requests;
  },
  SET_REQUEST_LOADED(state, loaded) {
    state.requestsLoaded = loaded;
  },
  CLEAR_REQUEST_DATA(state) {
    state.stock_requests = [];
    state.requestsLoaded = false;
  },
};

const actions = {
  async fetchRequestsData({ state, commit }) {
    if (state.requestsLoaded) return;
    try {
      const [stockreqRes] = await Promise.all([
        axiosInstance.get("supply_request/"),
      ]);
      commit("SET_STOCK_REQUESTS", stockreqRes.data);
      commit("SET_REQUEST_LOADED", true);
    } catch (error) {
      console.error("Failed to fetch onboard data:", error);
    }
  }
};

const getters = {
  getStockRequests: (state) => state.stock_requests,
  isRequestsLoaded: (state) => state.requestsLoaded,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};